import React, {
  useMemo,
  useEffect,
  useState,
} from 'react';
import styled, { withTheme } from 'styled-components/macro';
import { ErrorBoundaryEditor, PageRenderer } from 'containers';
import { 
  getPageFromSlug,
  getPageFromSlugOnSupport,
} from 'services/requests'
import PropTypes from 'prop-types';
import { useRouterContext } from 'hooks';
import { useHistory } from 'react-router-dom'
import { useUserContext, isUserSubwebAdmin } from 'context/UserContext';
import {
  Layout,
} from 'components/organisms';
import {
  HelperTitle
} from 'components/atoms';

const SUBWEB = 'ajuda-editor'

// TODO: see if is possible to add the subweb navigation bar (check portal implementation)
const Page = ({
  initialProps
}) => {

  const {
    match: {
      params: {
        slug
      },
    },
  } = useRouterContext();

  const [{ user }] = useUserContext()
  const history = useHistory()
  const [page, setPage] = useState(null)

  // check if user is admin
  const isAdmin = (user && user.admin) || isUserSubwebAdmin(user, SUBWEB)


  const getPage = async () => {  
    try {
      const { data } = await getPageFromSlugOnSupport({ slug: slug === undefined ? 'index' : slug, subweb: SUBWEB })

      if (data) {
        setPage(data)
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleHrefClick = (e) => {
    // e.target was the clicked element
    if (e.target && e.target.nodeName === 'A' && String(e.target.href).includes(`/${SUBWEB}`)) {
      e.preventDefault()

      // get the href last path 
      const slug = e.target.href.split('/').pop()

      // go to new page
      history.push(`/support/${slug}`)
    }
  }

  useEffect(() => {

    document.body.addEventListener('click', handleHrefClick);

    if (isAdmin) {
      getPage()
    }

    return () => {
      document.body.removeEventListener('click', handleHrefClick)
    }

  }, [slug]) 

  
  const pageLiveData = useMemo(() => {

    if (page && page.pageContent) {
      return page.pageContent.filter(el => el !== null) ?? []
    }
    return []
  }, [page])

  return (
    <Layout>
      <Home>
        {
          page !== null && (
            <ErrorBoundaryEditor subweb={SUBWEB} pageId={slug}>
              <PageRenderer
                page={pageLiveData}
                lang="pt"
                isPreview
              />
            </ErrorBoundaryEditor>
          )
        }
      </Home>
    </Layout>
  )
}

const Top = styled.div`
  padding-bottom: ${props => props.theme.spacing.md};
  display: flex;
  justify-content: space-between;
`

const Home = styled.div`
  ${HelperTitle} {
    margin-bottom: ${props => props.theme.spacing.l};
  }
  ${props => props.theme.mixins.select()};
`;

Home.Header = styled.div`
  margin-bottom: ${props => props.theme.spacing.l};
`;


Page.propTypes = {
  initialProps: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
    to: PropTypes.array
  }),
};

Page.defaultProps = {
  initialProps: {
    title: '',
    message: '',
    to: []
  }
};
export default withTheme(Page);
